/* Shto jump: a button or rating line inside our sections that links to "#something" on the page glides there, without
   adding "#..." to the address (development.md soft rule).
   Relaxe's theme is Prestige 3.1. When its header is sticky (#shopify-section-header, position: sticky) it stays on screen
   both ways, so every jump stops with the target just under it. Loaded by every section with a jump link; runs once. */
(function () {
  if (window.ShtoJump) return;
  window.ShtoJump = true;

  // A page opens at the top even when its address ends in #shto-... (a link shared with a section's id). The address
  // itself is never changed.
  if (/^#shto-/.test(location.hash)) {
    var toTop = function () { window.scrollTo({ top: 0, behavior: 'instant' }); };
    toTop();
    if (document.readyState === 'complete') setTimeout(toTop, 0);
    else window.addEventListener('load', function () { toTop(); setTimeout(toTop, 0); }, { once: true });
  }

  function headerHeight() {
    var h = document.getElementById('shopify-section-header');
    if (!h) return 0;
    var pos = getComputedStyle(h).position;
    return pos === 'sticky' || pos === 'fixed' ? h.getBoundingClientRect().height : 0;
  }

  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.shto a[href^="#"]');
    if (!link || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var id = decodeURIComponent(link.getAttribute('href').slice(1));
    var target = id && document.getElementById(id);
    if (!target) return;
    e.preventDefault();

    function where() {
      var y = target.getBoundingClientRect().top + window.scrollY;
      return Math.max(0, Math.round(y - headerHeight()));
    }
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: where(), behavior: still ? 'auto' : 'smooth' });
    // Photos loading on the way can move the target while the page glides. Once it stops, nudge it into place.
    var done = false;
    function settle() {
      if (done) return; done = true;
      window.removeEventListener('scrollend', settle);
      var off = where() - Math.round(window.scrollY);
      if (Math.abs(off) > 1) window.scrollBy({ top: off, behavior: still ? 'auto' : 'smooth' });
    }
    if ('onscrollend' in window) {
      window.addEventListener('scrollend', settle);
      if (Math.abs(window.scrollY - where()) < 2) settle(); // nothing to scroll: no scrollend comes
    } else setTimeout(settle, 1500);
    if (target.tabIndex < 0 && !/^(A|BUTTON|INPUT|SELECT|TEXTAREA)$/.test(target.tagName)) target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  });
})();
